// extracted by mini-css-extract-plugin
export var collapsedSummary = "_kj-0";